export default __webpack_public_path__ + "static/media/about_img2.e78026ba.svg";